import { language } from '../utils/language';
import convertArrToObj from '../utils/convertArrToObj';

export const BILL_CREATE_TYPE_ONE_MONTH = 'ONE_MONTH';
export const BILL_CREATE_TYPE_MORE_ONE_MONTH = 'MORE_ONE_MONTH';
export const BILL_CREATE_TYPE_PART_OF_MONTH = 'PART_OF_MONTH';
export const BILL_CREATE_TYPE_CUSTOM_HALF_OF_MONTH = 'CUSTOM_HALF_OF_MONTH';

export const BILL_CREATE_TYPES = [
  { id: BILL_CREATE_TYPE_ONE_MONTH, name: language.one_month },
  { id: BILL_CREATE_TYPE_MORE_ONE_MONTH, name: language.from_month_to_month },
  { id: BILL_CREATE_TYPE_PART_OF_MONTH, name: language.from_date_to_date },
  { id: BILL_CREATE_TYPE_CUSTOM_HALF_OF_MONTH, name: language.half_of_month },
];

export const BILL_TYPE_FULL_MONTH = 'FULL_MONTH';
export const BILL_TYPE_PART_OF_MONTH = 'PART_OF_MONTH';
export const BILL_TYPE_CUSTOM_HALF_OF_MONTH = 'CUSTOM_HALF_OF_MONTH';

export const BILL_TYPE = [
  { id: 'FULL_MONTH', name: language.label.bill_full_month },
  { id: 'PART_OF_MONTH', name: language.label.bill_part_of_month },
  { id: 'CUSTOM_HALF_OF_MONTH', name: language.label.bill_option },
];

export const BILL_TYPE_BY_ID = convertArrToObj(BILL_TYPE, 'id');

export const BILL_ACTIVE = 'ACTIVE'; // Bill active
export const BILL_DISABLED = 'DISABLED'; // Bill has been deleted
export const BILL_CANCELLED = 'CANCELLED'; // Bill has been cancelled

export const BILL_PAID = 'PAID'; // Bill has been paid
export const BILL_UNPAID = 'UNPAID'; // Bill unpaid
export const BILL_IN_PROCESS = 'IN_PROCESS'; // Bill is in processing
export const BILLS_PARTIAL_PAID = 'PARTIAL_PAID'; // Bill has been partial paid
export const EMPTY = 'EMPTY'; // Bill is adjust down

export const BILL_INCURRED_CREATED_FOR_INVALID = 'BILL_INCURRED_CREATED_FOR_INVALID';
export const EXISTS_ADJUST_BILL_HAVE_NOT_CANCELLED_YET = 'EXISTS_ADJUST_BILL_HAVE_NOT_CANCELLED_YET';
export const ORIGIN_BILL_CAN_NOT_ADJUST = 'ORIGIN_BILL_CAN_NOT_ADJUST';
export const ADJUST_BILL_CAN_NOT_UPDATE = 'ADJUST_BILL_CAN_NOT_UPDATE';
export const BILL_CREATED_BEFORE_LOCK_DATE = 'BILL_CREATED_BEFORE_LOCK_DATE';
export const DEBT_MONTH_TYPE = 'DEBT_MONTH';
export const INCURRED_MONTH_TYPE = 'INCURRED_MONTH';
export const FEE_NOTIFICATION_MONTH_TYPE = 'FEE_NOTIFICATION_MONTH';

export const BILL_STATE_OPTIONS = [
  { id: BILL_ACTIVE, name: language.label.close },
  { id: BILL_CANCELLED, name: language.label.void },
];

export const BILL_PAYMENT_STATE_OPTIONS = [
  { id: BILL_UNPAID, name: language.label.unpaid },
  { id: BILL_PAID, name: language.label.paid },
  { id: BILLS_PARTIAL_PAID, name: language.label.partial_paid },
  { id: EMPTY, name: language.label.empty },
];

export const BILL_TYPE_ADJUST_UP = 'ADJUST_UP';
export const BILL_TYPE_ADJUST_DOWN = 'ADJUST_DOWN';

export const ADJUST_TYPE = [
  { id: BILL_TYPE_ADJUST_UP, name: language.label.adjust_up },
  { id: BILL_TYPE_ADJUST_DOWN, name: language.label.adjust_down },
];

export const INVOICE_BILL_TYPE_BILL_FILTER = [
  { id: 'NORMAL', name: language.label.invoice1 },
  { id: 'DEBT', name: language.label.debt_bill },
  { id: 'ADJUSTED', name: language.label.bill_have_adjust },
  { id: 'ADJUST_UP', name: language.label.voucher_adjust_up },
  { id: 'ADJUST_DOWN', name: language.label.voucher_adjust_down },
];

export const INVOICE_BILL_ADJUST = [BILL_TYPE_ADJUST_UP, BILL_TYPE_ADJUST_DOWN];

export const INVOICE_TYPE_CREATED_FOR = [
  { id: DEBT_MONTH_TYPE, name: language.label.debt_month1 },
  { id: FEE_NOTIFICATION_MONTH_TYPE, name: language.label.fee_notification_month },
];

export const BILL_LIST_DEFAULT_FILTER = {
  createdForType: FEE_NOTIFICATION_MONTH_TYPE,
  time: [],
  billType: [],
  state: BILL_ACTIVE,
  paymentState: [BILL_UNPAID, EMPTY],
  code: '',
  unitName: '',
  unitType: '',
  serviceIds: [],
};
